module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.3500/js/img/Service.svg"